<template>
  <AppWithLoading v-slot:default="{loader, localLoading}">
    <div v-if="!localLoading">
      <AppDialog
        v-model="dialog"
        max-width="1178"
      >
        <template v-slot:activator="{ on, attrs }">
          <div class="d-flex align-center">
            <span class="mr-1">{{ $t('next') }} </span>
            <VIcon
              class="material-icons"
              v-bind="attrs"
              v-on="on"
            >
              mdi-close-circle-outline
            </VIcon>
          </div>
        </template>
        <VCard class="next-plan-cancel">
          <div class="next-plan-cancel__title">
            <div class="next-plan-cancel__icon">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.35 1H13.65L1 13.65V34.35L13.65 47H34.35L47 34.35V13.65L34.35 1Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M23.9998 30.9C22.0448 30.9 20.5498 32.395 20.5498 34.35C20.5498 36.305 22.0448 37.8 23.9998 37.8C25.9548 37.8 27.4498 36.305 27.4498 34.35C27.4498 32.395 25.9548 30.9 23.9998 30.9Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linejoin="round"
                />
                <path
                  d="M24.0002 26.3C25.2652 26.3 26.0702 25.61 26.3002 24.575C26.5302 23.54 27.2202 16.41 27.4502 12.615C27.5652 10.545 25.9552 9.04999 24.0002 9.04999C22.0452 9.04999 20.4352 10.545 20.5502 12.615C20.7802 16.41 21.4702 23.54 21.7002 24.575C21.9302 25.61 22.7352 26.3 24.0002 26.3Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            {{ $t('nextPlanCancelDialogTitle') }}
          </div>
          <div v-if="plan && nextPlan && burnDateText && paymentDateText" class="next-plan-cancel__text">
            {{ $t('nextPlanCancelDialog', { planTitle: plan.title, nextPlanTitle: nextPlan.title, burnDate: burnDateText, paymentDate: paymentDateText }) }}
            <div v-if="plan && nextPlan && burnDateText && paymentDateText" class="next-plan-cancel__text-bottom">
              <VCheckbox v-model="cancelPlan" :label="$t('cancelPlan', { current: plan.title, next: nextPlan.title, })" />
              <span v-if="nextPeriod">
                <VCheckbox v-model="cancelPeriod" :label="$t('cancelPeriod', { current: $tc('months',period.duration,{count: period.duration}), next: $tc('months',nextPeriod.duration,{count: nextPeriod.duration}), })" />
              </span>
            </div>
          </div>
          <div class="next-plan-cancel__btn-wrap">
            <button
              :disabled="!cancelPeriod && !cancelPlan"
              class="next-plan-cancel__btn next-plan-cancel__btn_cancel"
              @click="loader(() => cancelNextPlanAndCloseDialog())"
            >
              {{ $t('cancelNextPlan') }}
            </button>
            <button
              class="next-plan-cancel__btn"
              @click="dialog = false"
            >
              {{ $t('cancel') }}
            </button>
          </div>
        </VCard>
      </AppDialog>
    </div>
  </AppWithLoading>
</template>

<script>
import AppDialog from '@/components/AppDialog';
import useAccount from '@/compositions/accounting/useAccount';
import { computed, ref } from '@vue/composition-api';
import AppWithLoading from '@/components/AppWithLoading';
import moment from 'moment';
import { useI18n } from 'vue-i18n-composable';

export default {
  name: 'CancelNextPlan',
  components: { AppWithLoading, AppDialog },
  setup(_, { emit }) {
    const dialog = ref(false);
    const cancelPlan = ref(true);
    const cancelPeriod = ref(true);
    const { account, cancelNextPlan } = useAccount();
    const { locale } = useI18n();

    const plan = computed(() => account.value?.plan);
    const period = computed(() => account.value?.period);

    const burnDateText = computed(() => {
      const burnDate = account.value?.quotaBurnDate;

      if (!burnDate) {
        return '';
      }

      if (locale.value.toLowerCase() === 'ru') {
        return moment(burnDate)
          .locale(locale.value.toLowerCase()).format('DD.MM.YYYY');
      }

      return moment(burnDate)
        .locale(locale.value.toLowerCase()).format('MM/DD/YYYY');
    });

    const paymentDateText = computed(() => {
      const paymentDate = account.value?.next.paymentDate;

      if (!paymentDate) {
        return '';
      }

      if (locale.value.toLowerCase() === 'ru') {
        return moment(paymentDate)
          .locale(locale.value.toLowerCase()).format('DD.MM.YYYY');
      }

      return moment(paymentDate)
        .locale(locale.value.toLowerCase()).format('MM/DD/YYYY');
    });

    const nextPlan = computed(() => account.value?.nextPlan);
    const nextPeriod = computed(() => account.value?.nextPeriod);

    if (!nextPeriod.value) {
      cancelPeriod.value = false;
    }

    async function cancelNextPlanAndCloseDialog() {
      dialog.value = false;
      await cancelNextPlan(cancelPlan.value, cancelPeriod.value);
      emit('fetchData');
    }

    return {
      dialog,
      cancelNextPlanAndCloseDialog,
      plan,
      period,
      nextPlan,
      nextPeriod,
      cancelPlan,
      cancelPeriod,
      burnDateText,
      paymentDateText,
    };
  },
};
</script>

<style lang="scss" scoped>
.plan-link {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.375;
  color: #0A82D9;
  svg {
    margin-left: 0.625rem;
    vertical-align: middle;
  }
}
.dashboard-payment-btn {
  display: block;
  padding: 0.4375rem 1.125rem;
  border: 1px solid #D6D6D6;
  border-radius: 0.25rem;
  margin-left: auto;
}
.next-plan-cancel {
  padding: 2.125rem 1.25rem 3.125rem;
  text-align: center;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 8.25rem;
    height: 8.25rem;
    background: #FF0000;
    border: 1rem solid #ffe6e6;
    border-radius: 50%;
    margin: 0 auto 1.25rem auto;
  }
  &__title {
    font-size: 2.125rem;
    font-weight: 400;
    line-height: 1.32;
    color: #091A35;
    margin-bottom: 0.625rem;
  }
  &__text {
    width: 100%;
    max-width: 45rem;
    font-size: 1.0625rem;
    font-weight: 400;
    line-height: 1.53;
    color: #091A35;
    margin: 0 auto 2.5rem auto;
  }
  &__text-bottom {
    margin-top: 1rem;
  }
  &__btn {
    display: inline-block;
    padding: 1rem 1.25rem;
    border: 1px solid #D6D6D6;
    line-height: 1.15;
    font-weight: 400;
    letter-spacing: 0.02em;
    border-radius: 0.25rem;
    margin-right: 1.25rem;
    &_cancel {
      background-color: #FFFFFF;
      color: #EA0D0D;
      border-color: #EA0D0D;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .dashboard-payment-btn {
    margin: 0 auto;
  }
  .next-plan-cancel {
    &__icon {
      width: 6.875rem;
      height: 6.875rem;
      border-width: 0.83rem;
      svg {
        padding: 0.25rem;
      }
    }
    &__title {
      font-size: 1.5rem;
      font-weight: 500;
      line-height: 1.1;
      margin-bottom: 1.125rem;
    }
    &__text {
      max-width: 25rem;
      font-size: 1rem;
    }
    &__btn {
      padding: 0.875rem 1.25rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .dashboard-payment-btn {
    font-size: 0.8125rem;
  }
  .next-plan-cancel {
    padding: 1.875rem 1.125rem 2rem;
    &__icon {
      width: 5.5rem;
      height: 5.5rem;
      border-width: 0.67rem;
      svg {
        padding: 0.5rem;
      }
    }
    &__title {
      font-size: 1.375rem;
      font-weight: 500;
      line-height: 1.1;
      margin-bottom: 1rem;
    }
    &__text {
      max-width: 18.5rem;
      font-size: 0.9375rem;
      margin: 0 auto 1.5rem;
    }
    &__btn {
      display: block;
      margin: 0 auto 1.25rem auto;
      &:last-child {
        margin-right: auto;
        margin-bottom: 0;
      }
    }
  }
}
</style>

<i18n lang="yml" locale="ru">
cancel: Отмена
cancelNextPlan: Отменить изменение тарифа
next: Следующий
nextPlanCancelDialogTitle: Cледующий тариф
nextPlanCancelDialog: Сейчас у вас оформлена подписка на тариф «{planTitle}», но {burnDate} запланирован переход на тариф «{nextPlanTitle}». Если вы отмените переход на новый тариф, {paymentDate} с вас будет списана сумма по условиям текущего тарифа.
cancelPlan: Отменить переход с тарифа {current} на {next}
cancelPeriod: Отменить переход с периода {current} на {next}
months: '{count} месяцев | {count} месяц | {count} месяца | {count} месяцев'
</i18n>
<i18n lang="yml" locale="en">
cancel: Cancel
cancelNextPlan: Cancel plan change
next: Next
nextPlanCancelDialogTitle: Cancel plan change
nextPlanCancelDialog: You are now on a “{planTitle}” plan, and you have a downgrade scheduled on {burnDate}. If you cancel the plan change, on {paymentDate} you will be charged according to the terms of the current plan.
cancelPlan: Cancel changing «{current}» on «{next}» plan
cancelPeriod: Cancel changing «{current}» on «{next}» period
months: 'months | {count} month | {count} months'
</i18n>
